import { useContext } from "react"
import { IntegracaoFoodyDeliveryContext } from "./IntegracaoFoodyDeliveryContext"

export function useIntegracaoFoodyDeliveryContext() {
    return useContext(IntegracaoFoodyDeliveryContext)
}
